import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function GemIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M21.8315 9.45L17.8315 3.45C17.6515 3.17 17.3315 3 17.0015 3H7.00152C6.67152 3 6.35152 3.17 6.17152 3.45L2.17152 9.45C1.91152 9.83 1.95152 10.33 2.26152 10.67L11.2615 20.67C11.4515 20.88 11.7215 21 12.0015 21C12.2815 21 12.5515 20.88 12.7415 20.67L21.7415 10.67C22.0515 10.33 22.0915 9.83 21.8315 9.45ZM19.0015 9C19.0015 9.55 18.5515 10 18.0015 10C17.4515 10 16.9515 10.22 16.5915 10.59C16.2215 10.95 16.0015 11.45 16.0015 12C16.0015 12.55 15.5515 13 15.0015 13C14.4515 13 14.0015 12.55 14.0015 12C14.0015 11.45 13.7815 10.95 13.4115 10.59C13.0515 10.22 12.5515 10 12.0015 10C11.4515 10 11.0015 9.55 11.0015 9C11.0015 8.45 11.4515 8 12.0015 8C12.5515 8 13.0515 7.78 13.4115 7.41C13.7815 7.05 14.0015 6.55 14.0015 6C14.0015 5.45 14.4515 5 15.0015 5C15.5515 5 16.0015 5.45 16.0015 6C16.0015 7.1 16.9015 8 18.0015 8C18.2215 8 18.4315 8.08 18.6015 8.2C18.7815 8.34 18.9115 8.53 18.9615 8.75C18.9915 8.83 19.0015 8.91 19.0015 9Z" />
        </SvgIcon>
    );
}

export default GemIcon;
